import React from "react";
import {
	Button,
	Card,
	CardHeader,
	CardBody,
	CardTitle,
	Row,
	Col,
	Table,
	UncontrolledTooltip,
	Input,
	FormGroup,
	Alert,
	Collapse,
	Label
} from "reactstrap";
import Async from 'react-select/async';
import moment from "moment";
import { isEqual } from 'lodash';

// Requets
import { getLettersRequest, deleteLetterRequest, markLettersAsSent } from '../../api/letter';
import { getClientRequest, getClientsRequest } from "../../api/client";
import { saveScannedLetterRequest } from "api/image";
// Helpers
import { calcStartEndPage } from '../../helpers/pagination';
import { formatLetterStatus } from "../../helpers/status";
import { formatLetterType, formatLetterSubtype } from '../../helpers/letter';
import { hasPermission } from "helpers/auth";
//Constans
import { letterTypes, letterSubtypes, letterStatuses } from "../../constants";
// Components
import PaginationComponent from "../../components/Custom/Pagination";
import ConfirmationModal from "../../components/ConfirmationModal/ConfirmationModal";
import MarkAsSentModal from "../../components/Letter/MarkAsSentModal";
// Contexts
import ProjectContext from "contexts/ProjectContext";
// Assets
import { ReactComponent as IEye } from '../../assets/icons/eye.svg'
import { ReactComponent as ISlashedEye } from '../../assets/icons/slashedEye.svg'
import { ReactComponent as IClear } from '../../assets/icons/clear.svg'
class Letters extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			letters: null,
			total: 0,
			pages: 0,
			current_page: 0,
			start_page: 0,
			end_page: 9,
			first_page: 0,
			last_page: 0,
			deleteLetterId: '',
			selectedLetters: {},
			letterBulkSuccess: null,
			letterBulkMessage: null,
			markAsSentError: null,
			markingAsSent: false,
			letterFilters: {limit: 25, type: '', subtype: '', search: '', status: ''},
			clientsFilters: {},
			selectedClient: null,
			isCollapseOpen: true,
			loading: true
		}
		this.timeout = null;
	}

	static contextType = ProjectContext;

	componentDidMount() {
		this.previousContext = this.context;
		const { selectedProject } = this.context
		const letterFilters = JSON.parse(localStorage.getItem('letterFilters')) || this.state.letterFilters;
		if(letterFilters.client) {
			getClientRequest(letterFilters.client).then(client => {
				this.setState({
					selectedClient: { label: `${client.first_name} ${client.last_name}`, value: client._id, data: client }
				});
			})
		}

		this.setState({
			letterFilters: {
				...letterFilters,
				page: letterFilters.page || 0
			},
			current_page: letterFilters.page || 0
		}, () => {
			if (selectedProject) {
				this.getLetters();
			}
		});
	}

	async componentDidUpdate(prevProps, prevState) {
		if(this.previousContext.selectedProject !== this.context.selectedProject) {
			this.previousContext.selectedProject = this.context.selectedProject
			await this.getLetters()
		}

		if(!isEqual(prevState.letterFilters, this.state.letterFilters)) {
			this.setState({
				current_page: 0
			});
			localStorage.setItem('letterFilters', JSON.stringify({...this.state.letterFilters, page: 0}));
		}

		if(this.state.current_page !== prevState.current_page) {
			const letterFilters = JSON.parse(localStorage.getItem('letterFilters'));
			localStorage.setItem('letterFilters', JSON.stringify({ ...letterFilters, page: this.state.current_page }));
		}
	}

	getLetters = async () => {
		this.setState({loading: true})
		const { letterFilters } = this.state;
		const { selectedProject } = this.context


		letterFilters.project = selectedProject
		const lettersObj = await getLettersRequest(letterFilters);
		const letters = lettersObj.letters;
		const total = lettersObj.total;
		const pages = Math.ceil(total / letterFilters.limit);
		const last_page = pages - 1;
		const { start_page, end_page } = calcStartEndPage(0, pages);

		this.setState({
			letters,
			total,
			pages,
			start_page,
			last_page,
			end_page,
			loading: false
		})
	}

	goTo = path => this.props.history.push(path);

	goToNewTab = (path) => {
		const url = `${process.env.REACT_APP_BASE_URL}${path}`
		window.open(url, '_blank');
	}

	goToPage = async (page) => {
		const { letterFilters, pages } = this.state;
		
		const lettersObj = await getLettersRequest({...letterFilters, page});
		const letters = lettersObj.letters;
		const { start_page, end_page } = calcStartEndPage(page, pages);

		this.setState({
			letters,
			current_page: page,
			start_page: start_page,
			end_page: end_page
		})
	}

	loadClients = async (search, callback) => {
		const { clientsFilters } = this.state;
		const { selectedProject } = this.context

		const updatedClientFilters = {
			...clientsFilters,
			search,
			project: selectedProject
		}

		this.setState({
			clientsFilters: updatedClientFilters,
		});
		if(search) {
			const clientResponse = await getClientsRequest(updatedClientFilters);
			const clients = clientResponse.clients.map(client => {
				return {
					data: client,
					label: `${client.first_name} ${client.last_name}`,
					value: client._id
				}
			})
			callback(clients);
		}
	}

	onChangeSearch = (event) => {
		const { letterFilters } = this.state;
		this.setState({
			letterFilters: {
				...letterFilters,
				search: event.target.value,
				page: 0
			}
		})
		if (this.timeout) {
			clearTimeout(this.timeout);
		}
		this.timeout = setTimeout(() => {
			this.getLetters();
		}, 300);
	}
	
	onChangeType = (event) => {
		const { letterFilters } = this.state;
		this.setState({
			letterFilters: {
				...letterFilters,
				type: event.target.value
			},
		}, this.getLetters);
	}

	onChangeSubtype = (event) => {
		const { letterFilters } = this.state;
		this.setState({
			letterFilters: {
				...letterFilters,
				subtype: event.target.value
			},
		}, this.getLetters);
	}

	onChangeStatus = (event) => {
		const { letterFilters } = this.state;
		this.setState({
			letterFilters: {
				...letterFilters,
				status: event.target.value
			},
		}, this.getLetters);
	}

	onSelectChange = (key) => (object) => {
		const { letterFilters } = this.state;
		if(!object) {
            this.setState({
                letterFilters: {...letterFilters, [key]: ""},
				selectedClient: null
            }, () => {
                this.getLetters();
            })
            return;
        }

		this.setState({
			letterFilters: {
				...letterFilters,
				client: object.value,
			},
			selectedClient: object
		}, () => {
			this.getLetters();
		})
	}
	
	isValidStartDate = (current) => {
		return current < moment();
	}

	isValidEndDate = (current) => {
		if(this.state.start_date) {
			return current < moment() && current.diff(this.state.start_date, 'days') > 0;
		} else {
			return current < moment();
		}
	}

	openConfirmation = (letterId) => () => {
		this.setState({
			deleteLetterId: letterId
		});
		this.deleteConfirmationModal.toggle();
    }

	deleteLetter = async () => {
		const { deleteLetterId } = this.state;
        await deleteLetterRequest(deleteLetterId);
        this.getLetters()
	}

	getSelectedLetterIds = () => {
		const { selectedLetters = {} } = this.state;
		return Object.keys(selectedLetters).filter(key => selectedLetters[key]);
	}

	selectAll = (event) => {
		const { letters } = this.state;
	
		let selectedLetters = {};
	
		letters.forEach(product => {
		  selectedLetters[product._id] = event.target.checked;
		});
		this.setState({
		  selectedLetters
		});
	}

	setSelectedLetter = (productId) => (event) => {
		const { checked } = event.target;
		
		this.setState((prevState) => ({
		  selectedLetters: {
			...prevState.selectedLetters,
			[productId]: checked
		  }
		}));
	}

	openMarkAsSentModal = () => {
		this.markAsSentModal.toggle();
	}

	markBulkLettersAsSent = async ({ sent_at, sent_by, postal_number, scannedLetterFile }) => {
		const { selectedLetters } = this.state;
		const letterIds = Object.keys(selectedLetters);
		try {
			this.setState({ markingAsSent: true })
			const scannedLetterUrls = await Promise.all(letterIds.map(async (letterId) => {
				const url = await saveScannedLetterRequest(letterId, scannedLetterFile);
				return url;
			}));
			const response = await markLettersAsSent({ letterIds, sent_at, sent_by, postal_number, scanned_letters: scannedLetterUrls });
			this.getLetters();
			this.markAsSentModal.toggle();
			this.setState({
				selectedLetters: {},
				letterBulkSuccess: true,
				letterBulkMessage: response.message,
				markingAsSent: false
			});	
		} catch(err) {
			this.setState({
				letterBulkSuccess: false,
				markAsSentError: err && err.message ? err.message : 'There was an unexpected error',
				markingAsSent: false
			});
		} finally {
			window.scrollTo(0, 0)
			setTimeout(() => this.setState({
				letterBulkSuccess: null,
				letterBulkMessage: null,
				markAsSentError: null,
				markingAsSent: false
			}), 5000);
		}
	}

	render() {

		const {
			letters,
			pages,
			current_page,
			start_page,
			end_page,
			selectedClient,
			selectedLetters,
			letterBulkSuccess,
			letterBulkMessage,
			markAsSentError,
			markingAsSent,
			letterFilters,
			isCollapseOpen,
			loading
		} = this.state;

		const {
			status,
			search,
			type,
			subtype
		} = letterFilters;

		return (
			<>
				<div className="content">
					<Row>
						<Col md="12">
							<Card>
								<CardHeader>
									<Row className='mb-3'>
										<Col>
											<CardTitle tag="h4">Letters</CardTitle>
										</Col>
									</Row>
									<Row>
										<Col className="d-flex justify-content-end">
											<Button id='show-hide' className="filters-btn" onClick={() => this.setState({ isCollapseOpen: !isCollapseOpen })}>
												{isCollapseOpen ? 
													<>
														<ISlashedEye/>
														<UncontrolledTooltip
															delay={0}
															target='show-hide'
														>
															Hide filters
														</UncontrolledTooltip>
													</>
												: 
													<>
														<IEye/>
														<UncontrolledTooltip
															delay={0}
															target='show-hide'
														>
															Show filters
														</UncontrolledTooltip>
													</>
												}
											</Button>
											<Button id="clean" className="filters-btn" onClick={() => this.setState({ letterFilters: {limit: 25, status: '', type: '', subtype: '', search: ''}, selectedClient: null }, this.getLetters)}>
												<IClear/>
												<UncontrolledTooltip
													delay={0}
													target='clean'
												>
													Clean filters
												</UncontrolledTooltip>
											</Button>
										</Col>
									</Row>
									<Collapse
										isOpen={isCollapseOpen}
									>
										<>
										{letterBulkMessage &&
											<Row>
												<Col md={12}>
													<Alert color={letterBulkSuccess ? 'success' : 'danger'} fade={false}>{letterBulkMessage}</Alert>
												</Col>
											</Row>
										}
										<Row>
											<Col>
												<FormGroup>
													<Label>Client</Label>
													<Async
														clearValue={""}
														value={selectedClient}
														name="client"
														options={[]}
														loadOptions={this.loadClients}
														className="basic-multi-select"
														classNamePrefix="select"
														onChange={this.onSelectChange('client')}
														placeholder="Client..."
														isClearable={true}
													/>
												</FormGroup>
											</Col>
										</Row>
										<Row>
											<Col>
												<FormGroup>
													<Label>Search</Label>
													<Input 
														placeholder="Search..." 
														value={search}
														type="text"
														onChange={this.onChangeSearch} 
													/>
												</FormGroup>
											</Col>
										</Row>
										<Row>
											<Col sm="6">
												<FormGroup>
													<Label>Type</Label>
													<Input className={type ? "mt-2" : 'mt-2 select__placeholder'} value={type} type="select" onChange={this.onChangeType}>
														<option value="">Select Type...</option>
														{
															letterTypes.map(type => {
																return <option key={type} value={type}>{formatLetterType(type)}</option>
															})
														}
													</Input>
												</FormGroup>
											</Col>
											<Col sm="6">
												<FormGroup>
													<Label>Subtype</Label>
													<Input className={subtype ? "mt-2" : 'mt-2 select__placeholder'} value={subtype} type="select" onChange={this.onChangeSubtype}>
														<option value="">Select Subtype...</option>
														{
															letterSubtypes.map(subtype => {
																return <option key={subtype} value={subtype}>{formatLetterSubtype(subtype)}</option>
															})
														}
													</Input>
												</FormGroup>
											</Col>
										</Row>
										<Row>
											<Col>
												<FormGroup>
													<Label>Status</Label>
													<Input className={status ? "mt-2" : 'mt-2 select__placeholder'} value={status} type="select" onChange={this.onChangeStatus}>
														<option value="">Select Status...</option>
														{
															letterStatuses.map(status => {
																return <option key={status} value={status}>{formatLetterStatus(status)}</option>
															})
														}
													</Input>
												</FormGroup>
											</Col>
										</Row>
									</>
									</Collapse>
									<Row>
										<Col sm='12' className='d-flex justify-content-end mt-3'>
											<Button disabled={this.getSelectedLetterIds().length ? false : true} color="primary" onClick={this.openMarkAsSentModal}>Mark selected as Sent</Button>
											{/* hasPermission('CreateLetter') ? <Button className="mt-3 add-btn" color="primary" onClick={() => this.goTo('/letter/create')}><i className="tim-icons icon-simple-add" /> Letter</Button> : null */}
										</Col>
									</Row>
								</CardHeader>
								<CardBody>
									<Table responsive>
										<thead className="text-primary">
											<tr>
												{hasPermission('EditLetter') ? <th></th> : null}
												<th>Send date</th>
												<th>Type</th>
												<th>Subtype</th>
												<th>Status</th>
												<th>Client</th>
												<th className="text-right">Actions</th>
											</tr>
										</thead>
										<tbody>
											{ loading ? 
												<tr>
													<td colSpan={10}>Loading...</td>
												</tr>
											:
											letters && letters.length
												? letters.map((letter) => {
													
													//FIXME: Quick fix to prevent page crash
													// when payment was deleted
													if (!letter.payment) {
														return null;
													}

													return (
														<tr key={letter._id}>
															{hasPermission('EditLetter') && 
															<td>
																<input 
																	type="checkbox" 
																	checked={!!selectedLetters[letter._id]} 
																	onChange={this.setSelectedLetter(letter._id)}
																	disabled={(letter.status === 'sent' || letter.status === 'canceled') && true }
																/>
															</td>
															}
                                                            <td>{moment(letter.send_date).format("MM/DD/YYYY")}</td>
															<td>{letter.type ? `${formatLetterType(letter.type)} - ${letter.payment.subtype}` : "N/A"}</td>
															<td>{letter.subtype ? formatLetterSubtype(letter.subtype) : "N/A"}</td>
															<td>{letter.status ? `${formatLetterStatus(letter.status)} ${letter.status === "open" && letter.payment.status === "completed" ? "(PMT Completed)" : ""}` : "N/A"}</td>
															<td>{letter.client ? `${letter.client.first_name} ${letter.client.last_name}` : "N/A"}</td>
															<td className="text-right">
																<Button
																	className="btn-link btn-icon"
																	color="success"
																	id={`tooltip-view-${letter._id}`}
																	size="sm"
																	onClick={() => this.goToNewTab(`/letter?id=${letter._id}`)}
																>
																	<i className="tim-icons icon-zoom-split" />
																</Button>
																<UncontrolledTooltip
																	delay={0}
																	target={`tooltip-view-${letter._id}`}
																>
																	View
                                                                </UncontrolledTooltip>
																{hasPermission('EditLetter') ? <>
																	<Button
																		className="btn-link btn-icon"
																		color="info"
																		id={`tooltip-edit-${letter._id}`}
																		size="sm"
																		onClick={() => this.goToNewTab(`/letter/edit?id=${letter._id}`)}
																	>
																		<i className="tim-icons icon-pencil" />
																	</Button>
																	<UncontrolledTooltip
																		delay={0}
																		target={`tooltip-edit-${letter._id}`}
																	>
																		Edit
																	</UncontrolledTooltip>
																	<Button
																		className="btn-link btn-icon"
																		color="danger"
																		id={`tooltip-delete-${letter._id}`}
																		size="sm"
																		onClick={this.openConfirmation(letter._id)}
																	>
																		<i className="tim-icons icon-simple-remove" />
																	</Button>
																	<UncontrolledTooltip
																		delay={0}
																		target={`tooltip-delete-${letter._id}`}
																	>
																		Delete
																	</UncontrolledTooltip>
																</> : null}
															</td>
														</tr>
													)
												})
												: <tr>
													<td colSpan="7">There's no letter to show</td>
												</tr>
											}
										</tbody>
									</Table>
									{letters?.length > 0 &&
										<PaginationComponent
											pages={pages}
											current_page={current_page}
											start_page={start_page}
											end_page={end_page}
											goToPage={this.goToPage}
										/>
                    }
								</CardBody>
							</Card>
						</Col>
					</Row>
					<ConfirmationModal
						ref={el => this.deleteConfirmationModal = el}
						title="Delete Letter?"
						buttons={[
							{ title: 'Cancel', className: 'btn-primary-override btn btn-primary' },
							{ title: 'Delete', className: 'btn-danger-override btn btn-danger', onClick: this.deleteLetter }
						]}
					>
						Are you sure you want to delete this letter?
					</ConfirmationModal>
					<MarkAsSentModal 
						onSave={this.markBulkLettersAsSent}
						error={markAsSentError}
						loading={markingAsSent}
						ref={(c) => this.markAsSentModal = c}
					/>
				</div>
			</>
		);
	}
}

export default Letters;
